import { render } from "./RelatorioOrcamento.vue?vue&type=template&id=09c82e04&scoped=true"
import script from "./RelatorioOrcamento.vue?vue&type=script&lang=js"
export * from "./RelatorioOrcamento.vue?vue&type=script&lang=js"

import "./RelatorioOrcamento.vue?vue&type=style&index=0&id=09c82e04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c82e04"]])

export default __exports__